import { render, staticRenderFns } from "./EditStaffDialog.vue?vue&type=template&id=3205544d&scoped=true&"
import script from "./EditStaffDialog.vue?vue&type=script&lang=js&"
export * from "./EditStaffDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditStaffDialog.vue?vue&type=style&index=0&id=3205544d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3205544d",
  null
  
)

component.options.__file = "EditStaffDialog.vue"
export default component.exports